module.exports = __webpack_public_path__ + "static/media/layer4-box.426f1bb5.png";